import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FcMenu, FcOrgUnit  } from "react-icons/fc"; 
 
import {  FaMoneyBillTrendUp  } from "react-icons/fa6";
import { TbReceiptTax  } from "react-icons/tb";
import { IoSendOutline } from "react-icons/io5";
import { AiOutlinePayCircle } from "react-icons/ai";
import HandleCurrentPath from "./HandleCurrentPath";
import { GiStakesFence, GiGlowingArtifact,GiClockwork } from "react-icons/gi"; 
const MobileHamburger = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);

  }; 
    const closeSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const pathname = window.location.pathname;
  
  return (
    <>
     {/* Mobile menu */}

     <aside
                className={`fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden ${isSideMenuOpen ? 'block' : 'hidden'}`}
                onClick={closeSideMenu}
            >
                <div className="py-4 text-gray-500 dark:text-gray-400">
          <Link
            className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
            href="#"
          >
           ....
          </Link>
          <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>
          <ul className="mt-6">
         
          <li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/paymentRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/paymentRequest'} >
         <FaMoneyBillTrendUp/>
         <span className="ml-4">Payment Requests </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/taxpayoutresponse'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/taxpayoutresponse'} >
         <TbReceiptTax />
         <span className="ml-4">Tax payout response </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/stkPushRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/stkPushRequest'} >
         <IoSendOutline/>
         <span className="ml-4">StkPushRequest </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/withdrawalRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/withdrawalRequest'} >
         <AiOutlinePayCircle/>
         <span className="ml-4">WithdrawalRequest </span>
     </Link>
</li>
            
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/receiveBulkStakes'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/receiveBulkStakes'} >
         <GiStakesFence/>
         <span className="ml-4">Stake Data </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/outcomeinfologs'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/outcomeinfologs'} >
         <GiGlowingArtifact/>
         <span className="ml-4">Bet Outcome Log</span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/dailytaxobligation'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/dailytaxobligation'} >
         <GiClockwork/>
         <span className="ml-4">Daily Tax Obligation </span>
     </Link>
</li>

          </ul>
          </div>

            </aside>
            {/* End mobile Menu */}
    <button
      className={`p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-purple ${isSideMenuOpen ? 'bg-blue-500' : 'bg-transparent'}`}
      onClick={toggleSideMenu}
      aria-label="Menu"
    >

        <FcMenu/>
      {/* <svg
        className="w-6 h-6 text-white"
        aria-hidden="false"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        />
      </svg> */}
    </button>
    </>
    
  );
};

export default MobileHamburger;